import React from 'react';

const Project_Protein = () => {
  return (
    <>
      <section
        data-aos="fade-up"
        style={{
          backgroundColor: '#eeeeee',
          padding: '70px 20px',
          textAlign: 'center',
          color: '#333',
        }}
      >
        <div className="container">
          <h1 style={{ fontWeight: 700, fontSize: '40px', color: '#000' }}>
            Project Protein – Premium Quality, Guaranteed Purity
          </h1>
          <p
            style={{
              marginTop: '15px',
              fontSize: '18px',
              color: '#666',
              maxWidth: '800px',
              marginInline: 'auto',
            }}
          >
            Every product is tested for purity, safety, and nutritional accuracy.
          </p>
        </div>
      </section>
        {/* WHY QUALITY MATTERS */}
      <section
        style={{
          padding: '0px 20px',
          backgroundColor: '#eeeeee',
          color: '#333',
        }}
      >
        <div className="container">
          <div className="row align-items-center">
            <div
              className="col-12 col-md-6 mb-4 mb-md-0 fresh-image-2"
              data-aos="fade-right"
            >
              <img
                src="/assets/images/new-images/Yeast Protein Double chocolate & Cafe Mocha Combo.png"
                alt="Fresh Image"
                className="resimg"
                style={{
                  width: '100%',
                  maxWidth: '300px',
                  border: '1px solid #EDE7E6',
                  borderRadius: '10px',
                }}
              />
            </div>

            <div
              className="col-12 col-md-6"
              data-aos="fade-left"
            >
              <h2 style={{ fontSize: '32px', fontWeight: 700 }}>
                Why Protein is the Right Choice for You
              </h2>

              <div
                style={{
                  width: '60px',
                  height: '4px',
                  backgroundColor: 'black',
                  margin: '15px 0',
                }}
              ></div>

              <ul
                style={{
                  listStyle: 'none',
                  padding: 0,
                  fontSize: '18px',
                  color: '#666',
                  lineHeight: '30px',
                }}
              >
                <li style={{ fontSize: '17px' }}>✔ 100% purity & accurate protein profile</li>
                <br />
                <li style={{ fontSize: '17px' }}>✔ Lab-tested for safety & genuine ingredients</li>
                <br />
                <li style={{ fontSize: '17px' }}>
                  ✔ No duplicate, no fillers — only real nutrition
                </li>
                <br />
                <li style={{ fontSize: '17px' }}>✔ Supports faster muscle recovery & strength</li>
                <br />
                <li style={{ fontSize: '17px' }}>
                  ✔ Trusted quality you can rely on for fitness results
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Project_Protein;
